module.exports = __webpack_public_path__ + "img/news-05.cb531aba.jpg";